export default {
      id: "complex-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#complex-usage",
      toString: function () {
        return this.url;
      }
    }